import { render, staticRenderFns } from "./banSomeOpenid.vue?vue&type=template&id=ae69708a&"
import script from "./banSomeOpenid.vue?vue&type=script&lang=js&"
export * from "./banSomeOpenid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae69708a')) {
      api.createRecord('ae69708a', component.options)
    } else {
      api.reload('ae69708a', component.options)
    }
    module.hot.accept("./banSomeOpenid.vue?vue&type=template&id=ae69708a&", function () {
      api.rerender('ae69708a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banSomeOpenid.vue"
export default component.exports